import { Outlet } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import heading from '../assets/GB logo with white outline.avif'

const AuthLayout = () => {
  return (
    <>
      <Container className="d-flex flex-column align-items-center pt-5">
        <div className="mb-4">
          <img src={heading} style={{ width: '35rem', height: 'auto', maxWidth: '100%' }} alt="Logo" />
        </div>
        <Outlet />
      </Container>
    </>
  )
}
export default AuthLayout
